import React from 'react';

const steps = [
  {
    title: 'Create your team',
    description: 'Set up a free profile and add your squad in seconds.',
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6} aria-hidden>
        <path strokeLinecap="round" strokeLinejoin="round" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
      </svg>
    ),
  },
  {
    title: 'Challenge a rival',
    description: 'Find local opponents and send a match invite right away.',
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6} aria-hidden>
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
  },
  {
    title: 'Score & climb',
    description: 'Score ball-by-ball, build your stats, and rise up the leaderboard.',
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6} aria-hidden>
        <path strokeLinecap="round" strokeLinejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
      </svg>
    ),
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="cf-section">
      <div className="cf-container cf-rel-z">
        <div className="cf-section-head cf-reveal">
          <span className="cf-eyebrow">Get started</span>
          <h2 className="cf-h2">
            Up and running
            <br />
            <span className="cf-text-gradient">in 3 steps</span>
          </h2>
        </div>

        <div className="cf-steps">
          {steps.map((step, i) => (
            <div
              key={step.title}
              className="cf-step cf-reveal cf-reveal--left"
              style={{ '--cf-d': `${i * 0.12}s` }}
            >
              <div className="cf-step__rail">
                <div className="cf-step__dot">
                  {step.icon}
                  <span className="cf-step__badge">{i + 1}</span>
                </div>
                {i < steps.length - 1 && <div className="cf-step__line" />}
              </div>
              <div className="cf-step__body">
                <span className="cf-step__kicker">Step {i + 1}</span>
                <h3 className="cf-step__title">{step.title}</h3>
                <p className="cf-step__desc">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
